/**
 * @type {import("alpinejs")}
 */
var Alpine;

const UPSELL_COPY = {
  "4-8": {
    badge: "Bestseller!",
    heading: "4 is enough, until it isn't",
    description:
      "The 8 box is our bestselling size. Why? Because people hate running out of BWOWNIES.",
  },
  "4-12": {
    badge: "Best value",
    heading: "Go on, go for box of 12",
    description:
      "You'll regret not getting it. BWOWNIES always run out faster than you think.",
  },
  "8-12": {
    badge: "Free shipping when you buy 12!",
    heading: "Go on, go for the box of 12",
    description:
      "You'll regret not getting it. BWOWNIES always run out faster than you think.",
  },
};

document.addEventListener("alpine:init", () => {
  Alpine.store("buildABoxStore", {
    canAddMore: true,
    canRemoveMore: false,
    totalCount: 0,
    maxCount: parseInt(
      document.querySelector('[x-ref="buildABoxMain"]').dataset.max,
    ),
    chosenProducts: {},
    /** Product ids in order of first add — one cell per unique flavour */
    flavourOrder: [],
    /** @type {{ key: string, placeholder: boolean, imageUrl?: string, title?: string, quantity?: number }[]} */
    slotCells: [],
    propertyString: "",
    activeCollection: "all",
    variants: [],
    pendingForm: null,
    upsellDismissed: false,

    rebuildSlotCells() {
      const minSlots = 4;
      const unique = this.flavourOrder.length;
      const n = Math.max(minSlots, unique);
      this.slotCells = Array.from({ length: n }, (_, i) => {
        if (i < unique) {
          const productId = this.flavourOrder[i];
          const p = this.chosenProducts[productId];
          if (p?.imageUrl) {
            return {
              placeholder: false,
              productId,
              imageUrl: p.imageUrl,
              title: p.title,
              quantity: p.quantity,
              key: `flavour-${productId}`,
            };
          }
          return { placeholder: true, key: `ph-missing-${productId}` };
        }
        return { placeholder: true, key: `ph-${i}` };
      });
    },

    validate() {
      if (this.totalCount > 0) {
        this.canRemoveMore = true;
      } else {
        this.canRemoveMore = false;
      }

      if (this.totalCount >= this.maxCount) {
        this.canAddMore = false;
        window.dispatchEvent(
          new CustomEvent("open-bab-mobile-drawer", {
            bubbles: true,
            detail: {},
          }),
        );
      } else {
        this.canAddMore = true;
      }

      this.propertyString = this.boxContentsString();
      this.rebuildSlotCells();
    },

    boxContentsString() {
      return Object.values(this.chosenProducts)
        .filter((p) => p.quantity > 0)
        .map((p) => `${p.quantity}x ${p.title}`)
        .join(", ");
    },

    /** Slots still empty in the box (brownie count), clamped at 0 */
    remainingFlavourCount() {
      const cap = Number(this.maxCount);
      if (!Number.isFinite(cap)) return 0;
      return Math.max(0, cap - this.totalCount);
    },

    /** True when totalCount meets the selected bundle size */
    isBoxComplete() {
      const cap = Number(this.maxCount);
      return Number.isFinite(cap) && cap > 0 && this.totalCount >= cap;
    },

    /** Primary CTA label for the product form submit control */
    addToCartButtonLabel() {
      if (this.isBoxComplete()) return "Add to cart";
      const n = this.remainingFlavourCount();
      if (n === 1) return "Add 1 more flavour";
      return `Add ${n} more flavours`;
    },

    updateTotalCount(amount) {
      this.totalCount = this.totalCount + amount;
      this.validate();
    },

    updateMaxCount(amount) {
      this.maxCount = amount;

      if (this.totalCount == this.maxCount) {
        this.canAddMore = false;
      } else {
        this.canAddMore = true;
      }

      if (this.totalCount > this.maxCount) {
        this.resetBuilder();
      }
    },

    resetBuilder() {
      this.chosenProducts = {};
      this.flavourOrder = [];
      this.totalCount = 0;
      this.validate();
    },

    /**
     * Clears the box and fills it with random flavours (one roll per slot up to maxCount).
     * Catalog JSON lives in `#build-a-box-catalog` from Liquid.
     */
    surpriseMe() {
      const el = document.getElementById("build-a-box-catalog");
      if (!el) return;
      let catalog;
      try {
        catalog = JSON.parse(el.textContent.trim());
      } catch {
        return;
      }
      if (!Array.isArray(catalog) || catalog.length === 0) return;

      const cap = Number(this.maxCount);
      if (!Number.isFinite(cap) || cap <= 0) return;

      this.chosenProducts = {};
      this.flavourOrder = [];
      this.totalCount = 0;

      for (let i = 0; i < cap; i++) {
        const item = catalog[Math.floor(Math.random() * catalog.length)];
        const id = item.id;
        const qty = this.chosenProducts[id]?.quantity ?? 0;
        if (qty === 0) {
          this.flavourOrder.push(id);
        }
        this.chosenProducts[id] = {
          title: item.title,
          quantity: qty + 1,
          imageUrl: item.imageUrl || "",
        };
        this.totalCount++;
      }

      this.validate();
    },

    setActiveCollection(collection) {
      document.startViewTransition(() => {
        this.activeCollection = collection;
      });
    },

    initVariants() {
      const el = document.getElementById("build-a-box-variants");
      if (!el) return;
      try {
        this.variants = JSON.parse(el.textContent.trim());
      } catch {}
    },

    getCurrentVariant() {
      return this.variants.find((v) => v.count === this.maxCount) || null;
    },

    getNextVariant() {
      const current = this.getCurrentVariant();
      if (!current) return null;
      return this.variants.find((v) => v.count > current.count) || null;
    },

    getUpgradeVariants() {
      const current = this.getCurrentVariant();
      if (!current) return [];
      return this.variants.filter((v) => v.count > current.count);
    },

    shouldShowUpsell() {
      const hasUpgrades = this.getUpgradeVariants().length > 0;
      const hasBites = !!document.getElementById("bab-bites-data");
      return hasUpgrades || hasBites;
    },

    handleAddToCart(form) {
      if (!this.isBoxComplete()) return;
      if (!this.upsellDismissed && this.shouldShowUpsell()) {
        this.pendingForm = form;
        document.getElementById("bab-upsell-dialog").showModal();
        return;
      }
      form.requestSubmit();
    },
  });
  Alpine.store("buildABoxStore").rebuildSlotCells();
  Alpine.store("buildABoxStore").initVariants();

  Alpine.data("buildABoxUpsell", () => ({
    bitesQuantity: 1,
    bitesAdded: false,

    init() {
      this.$watch("$store.buildABoxStore.pendingForm", (form) => {
        if (form) {
          this.bitesQuantity = 1;
          this.bitesAdded = false;
        }
      });
    },

    get upgradeVariants() {
      return this.$store.buildABoxStore.getUpgradeVariants();
    },
    get currentVariant() {
      return this.$store.buildABoxStore.getCurrentVariant();
    },
    get dismissLabel() {
      const current = this.currentVariant;
      if (!current) return "";
      if (this.upgradeVariants.length > 0) {
        return `No thanks, I'll stick to my box of ${current.count}`;
      }
      return "Add to cart";
    },

    getCopyFor(targetVariant) {
      const current = this.currentVariant;
      if (!current) return { badge: "", heading: "", description: "" };
      const key = `${current.count}-${targetVariant.count}`;
      return (
        UPSELL_COPY[key] || {
          badge: "",
          heading: `Upgrade to box of ${targetVariant.count}`,
          description: "",
        }
      );
    },

    getUpgradeLabel(targetVariant) {
      const current = this.currentVariant;
      if (!current) return "";
      if (this.upgradeVariants.length === 1) {
        const pence = targetVariant.price - current.price;
        const pounds = pence / 100;
        const fmt = pounds % 1 === 0 ? `£${pounds}` : `£${pounds.toFixed(2)}`;
        return `Upgrade to a box of ${targetVariant.count} for just ${fmt}`;
      }
      return `Upgrade to a box of ${targetVariant.count}`;
    },

    upgrade(targetVariant) {
      const store = this.$store.buildABoxStore;
      store.upsellDismissed = true;
      document
        .querySelectorAll(`input[name="id"][value="${targetVariant.id}"]`)
        .forEach((r) => (r.checked = true));
      store.updateMaxCount(targetVariant.count);
      this.$refs.dialog.close();
      store.pendingForm = null;
    },

    dismiss() {
      const store = this.$store.buildABoxStore;
      store.upsellDismissed = true;
      this.$refs.dialog.close();
      if (store.pendingForm) {
        store.pendingForm.requestSubmit();
        store.pendingForm = null;
      }
    },

    decreaseBites() {
      if (this.bitesQuantity > 1) this.bitesQuantity--;
    },
    increaseBites() {
      this.bitesQuantity++;
    },
    async addBites() {
      const el = document.getElementById("bab-bites-data");
      if (!el) return;
      let bitesData;
      try {
        bitesData = JSON.parse(el.textContent.trim());
      } catch {
        return;
      }

      const store = this.$store.buildABoxStore;
      const items = [{ id: bitesData.variantId, quantity: this.bitesQuantity }];

      if (store.pendingForm) {
        const fd = new FormData(store.pendingForm);
        const variantId = fd.get("id");
        const boxItems = fd.get("properties[Items]");
        if (variantId) {
          const entry = { id: parseInt(variantId), quantity: 1 };
          if (boxItems) entry.properties = { Items: boxItems };
          items.push(entry);
        }
      }

      const isDrawer = window.theme?.settings?.cartType === "modal";
      const body = { items };
      if (isDrawer) {
        body.sections = "cart-items,cart-footer,cart-item-count";
        body.sections_url = window.location.pathname;
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        const data = await res.json();

        this.$refs.dialog.close();
        store.upsellDismissed = true;
        store.pendingForm = null;

        if (isDrawer) {
          document.body.dispatchEvent(
            new CustomEvent("shapes:cart:afteradditem", {
              bubbles: true,
              detail: { response: data },
            }),
          );
        } else {
          window.location.href = window.theme?.routes?.cart_url || "/cart";
        }
      } catch (e) {
        console.error("Failed to add items to cart", e);
      }
    },
  }));

  Alpine.data("buildABox", () => ({
    init() {
      this.$store.buildABoxStore.rebuildSlotCells();
    },
  }));

  Alpine.data("surpriseMeBtn", () => ({
    diceSpinning: false,
    surprise() {
      this.diceSpinning = true;
      this.$store.buildABoxStore.surpriseMe();
      setTimeout(() => {
        this.diceSpinning = false;
      }, 650);
    },
  }));

  Alpine.data("boxComponentCard", (productId, title, imageUrl) => ({
    productId,
    title,
    imageUrl: imageUrl || "",
    init() {},
    increaseQuantity() {
      const quantity =
        this.$store.buildABoxStore.chosenProducts[this.productId]?.quantity ??
        0;

      const store = this.$store.buildABoxStore;
      if (quantity === 0) {
        store.flavourOrder.push(this.productId);
      }

      store.chosenProducts[productId] = {
        title,
        quantity: quantity + 1,
        imageUrl: this.imageUrl,
      };

      store.updateTotalCount(1);
    },
    decreaseQuantity() {
      const quantity =
        this.$store.buildABoxStore.chosenProducts[this.productId]?.quantity ??
        0;
      if (quantity - 1 < 0) return;

      const store = this.$store.buildABoxStore;
      const nextQty = quantity - 1;

      if (nextQty === 0) {
        delete store.chosenProducts[productId];
        const o = store.flavourOrder.indexOf(this.productId);
        if (o !== -1) store.flavourOrder.splice(o, 1);
      } else {
        store.chosenProducts[productId] = {
          title,
          quantity: nextQty,
          imageUrl: this.imageUrl,
        };
      }

      store.updateTotalCount(-1);
    },
  }));
});
